const productId = window.productScriptConfig.productId;
const translations = window.productScriptConfig.translations;
console.log("productId", productId);
document.addEventListener("DOMContentLoaded", function () {
  const disponibilidadBtn = document.querySelector(
    ".disponibilidad-tiendas-btn",
  );
  const popup = document.querySelector(".disponibilidad-tiendas-content");
  const closeButton = document.querySelector(".icon-close");

  if (disponibilidadBtn && popup && closeButton) {
    disponibilidadBtn.addEventListener("click", function () {
      console.log("Botón de disponibilidad clicado");
      popup.classList.remove("hidden");
      document
        .getElementById("page-content")
        .classList.add("open-disponibilidad");
      document.body.classList.add("overflow-hidden");
      this.closest(".disponibilidad-tiendas-container").classList.add("active");
      if (
        document.querySelector(
          ".disponibilidad-tiendas-container .disponibilidad-tiendas-content",
        )
      ) {
        document.body.appendChild(
          document.querySelector(".disponibilidad-tiendas-content"),
        );
      }
    });

    closeButton.addEventListener("click", function () {
      popup.classList.add("hidden");
      document
        .getElementById("page-content")
        .classList.remove("open-disponibilidad");
      document.body.classList.remove("overflow-hidden");
    });
  } else {
    console.log("Uno o más elementos no encontrados");
  }
  moveButton();
});

fetchVariant(productId);

function fetchVariant(id) {
  const requestOptions = {
    method: "GET",
    redirect: "follow",
  };

  fetch(
    `https://paris64-app.fly.dev/variant-stock?productId=${id}`,
    requestOptions,
  )
    .then((response) => response.json())
    .then((result) => {
      console.log(result);

      // Mapeo de datos para obtener ubicaciones con sus variantes agrupadas
      const locationsData = {};

      // Iterar sobre cada variante para todas las localizaciones
      result.data.product.variants.edges.forEach((edge) => {
        const node = edge.node;

        // Iterar sobre cada ubicación de inventoryLevels.edges
        node.inventoryItem.inventoryLevels.edges.forEach((levelEdge) => {
          const locationName = levelEdge.node.location.name;

          // Si la ubicación no existe en locationsData, crearla
          if (!locationsData[locationName]) {
            // Reemplazar "/" con "<br>" en el valor de metafield si existe
            let metafieldValue = levelEdge.node.location.metafield
              ? levelEdge.node.location.metafield.value.replace("/", "<br>")
              : null;

            // Crear el objeto de la ubicación
            locationsData[locationName] = {
              name: locationName,
              city: levelEdge.node.location.address.city,
              address: levelEdge.node.location.address.address1,
              phone: levelEdge.node.location.address.phone,
              zip: levelEdge.node.location.address.zip,
              metafield: metafieldValue,
              variants: [],
              totalStock: 0, // Inicializamos el stock total en 0
            };
          }

          // Obtener título de la variante y stock
          const variantTitle = node.title;
          const stock = levelEdge.node.quantities[0].quantity;

          // Actualizar el stock total de la ubicación
          locationsData[locationName].totalStock += stock;

          // Verificar si la variante ya existe en la ubicación
          const existingVariant = locationsData[locationName].variants.find(
            (variant) => variant.title === variantTitle,
          );

          // Si la variante no existe, agregarla a la ubicación
          if (!existingVariant) {
            locationsData[locationName].variants.push({
              title: variantTitle,
              stock: stock,
            });
          }
        });
      });

      // Mostrar resultados finales para todas las localizaciones
      const locationsDataArray = Object.values(locationsData);

      const onlineStock = locationsDataArray.find(
        (location) => location.name === "Almacén central",
      ).variants;
      let containerTallas = document.querySelector(
        ".clickyboxes.options-talla",
      );
      if (containerTallas) {
        let optionsVariant = containerTallas.querySelectorAll("a");
        let selectedVariant = containerTallas
          .querySelector(".active")
          .getAttribute("data-value");
        optionsVariant.forEach((option) => {
          option.addEventListener("click", () => {
            let selectedVariantNew = option.getAttribute("data-value");
            let availableStock = onlineStock.find(
              (variant) => variant.title == selectedVariantNew,
            ).stock;
            let label = document.querySelector(
              ".product-inventory-notice__text",
            );
            let labelContainer = document.querySelector(
              ".product-inventory-notice",
            );
            if (availableStock == 0) {
              labelContainer.classList.remove("hidden-variants");
              label.innerText = "Agotado";
            } else if (availableStock > 0 && availableStock <= 3) {
              labelContainer.classList.remove("hidden-variants");
              label.innerText = translations.onlyXLeft.replace(
                "[qty]",
                availableStock,
              );
            } else {
              labelContainer.classList.add("hidden-variants");
            }
          });
        });
      }

      let html = "";
      // Iterar sobre las propiedades del objeto locationsData
      Object.values(locationsData).forEach((resultado) => {
        console.log(resultado.name);
        if (
          resultado.name !== "Almacén central" &&
          resultado.name !== "Warehouse NY" &&
          resultado.city !== ""
        ) {
          // Construir el HTML para cada tienda
          html += `<div class="city-store">

                    <div class="store-name">
                    ${
                      resultado.totalStock === 0
                        ? `<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.4999 9.79038L10.6767 12.0952C10.7747 12.199 10.898 12.2522 11.0465 12.2546C11.195 12.257 11.3205 12.2039 11.4231 12.0952C11.5257 11.9865 11.5771 11.8548 11.5771 11.7C11.5771 11.5452 11.5257 11.4135 11.4231 11.3048L9.24636 9.00001L11.4231 6.69519C11.5212 6.59135 11.5714 6.46083 11.5736 6.30361C11.5759 6.14641 11.5257 6.01349 11.4231 5.90484C11.3205 5.79618 11.1961 5.74184 11.0499 5.74184C10.9037 5.74184 10.7793 5.79618 10.6767 5.90484L8.4999 8.20964L6.32312 5.90484C6.22505 5.80099 6.10178 5.74786 5.9533 5.74546C5.80483 5.74305 5.67929 5.79618 5.57668 5.90484C5.47405 6.01349 5.42274 6.14521 5.42274 6.30001C5.42274 6.45481 5.47405 6.58654 5.57668 6.69519L7.75344 9.00001L5.57668 11.3048C5.4786 11.4087 5.42843 11.5392 5.42616 11.6964C5.42388 11.8536 5.47405 11.9865 5.57668 12.0952C5.67929 12.2039 5.8037 12.2582 5.9499 12.2582C6.0961 12.2582 6.22051 12.2039 6.32312 12.0952L8.4999 9.79038ZM8.50109 16.125C7.57038 16.125 6.69557 15.938 5.87664 15.564C5.0577 15.19 4.34534 14.6824 3.73956 14.0413C3.13377 13.4002 2.65419 12.6462 2.30082 11.7795C1.94744 10.9128 1.77075 9.98672 1.77075 9.00127C1.77075 8.01582 1.94736 7.08954 2.30059 6.22244C2.65381 5.35533 3.13317 4.60107 3.73868 3.95966C4.3442 3.31823 5.05624 2.81044 5.87482 2.43628C6.69338 2.06211 7.56801 1.87503 8.49871 1.87503C9.42942 1.87503 10.3042 2.06203 11.1232 2.43603C11.9421 2.81003 12.6545 3.31759 13.2602 3.95872C13.866 4.59986 14.3456 5.35379 14.699 6.22051C15.0524 7.08723 15.2291 8.01331 15.2291 8.99876C15.2291 9.98421 15.0524 10.9105 14.6992 11.7776C14.346 12.6447 13.8666 13.399 13.2611 14.0404C12.6556 14.6818 11.9436 15.1896 11.125 15.5638C10.3064 15.9379 9.43179 16.125 8.50109 16.125ZM8.4999 15C10.0818 15 11.4218 14.4188 12.5197 13.2563C13.6176 12.0938 14.1666 10.675 14.1666 9.00001C14.1666 7.32501 13.6176 5.90626 12.5197 4.74376C11.4218 3.58126 10.0818 3.00001 8.4999 3.00001C6.91796 3.00001 5.57803 3.58126 4.48011 4.74376C3.38219 5.90626 2.83323 7.32501 2.83323 9.00001C2.83323 10.675 3.38219 12.0938 4.48011 13.2563C5.57803 14.4188 6.91796 15 8.4999 15Z" fill="#CD4242"/>
                      </svg>
                      `
                        : `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M7.93556 10.6096L6.19324 8.86732C6.0894 8.76347 5.95888 8.71035 5.80166 8.70795C5.64445 8.70553 5.51152 8.75866 5.40287 8.86732C5.29422 8.97597 5.23989 9.1077 5.23989 9.2625C5.23989 9.4173 5.29422 9.54902 5.40287 9.65767L7.46104 11.7158C7.59661 11.8514 7.75479 11.9192 7.93556 11.9192C8.11632 11.9192 8.27449 11.8514 8.41007 11.7158L12.5827 7.54325C12.6865 7.43942 12.7396 7.30889 12.742 7.15168C12.7444 6.99447 12.6913 6.86153 12.5827 6.75288C12.474 6.64423 12.3423 6.58991 12.1875 6.58991C12.0327 6.58991 11.901 6.64423 11.7923 6.75288L7.93556 10.6096ZM9.00124 16.125C8.01579 16.125 7.08951 15.938 6.22241 15.564C5.3553 15.19 4.60104 14.6824 3.95963 14.0413C3.3182 13.4002 2.81041 12.6462 2.43624 11.7795C2.06208 10.9128 1.875 9.9867 1.875 9.00125C1.875 8.0158 2.062 7.08953 2.436 6.22243C2.81 5.35532 3.31756 4.60105 3.95869 3.95964C4.59983 3.31822 5.35376 2.81042 6.22048 2.43626C7.08719 2.0621 8.01328 1.87502 8.99873 1.87502C9.98418 1.87502 10.9105 2.06202 11.7776 2.43602C12.6447 2.81002 13.3989 3.31758 14.0403 3.9587C14.6818 4.59984 15.1896 5.35377 15.5637 6.2205C15.9379 7.08721 16.125 8.01329 16.125 8.99874C16.125 9.98419 15.938 10.9105 15.564 11.7776C15.19 12.6447 14.6824 13.3989 14.0413 14.0404C13.4001 14.6818 12.6462 15.1896 11.7795 15.5637C10.9128 15.9379 9.98669 16.125 9.00124 16.125ZM8.99998 15C10.675 15 12.0937 14.4187 13.2562 13.2562C14.4187 12.0937 15 10.675 15 9C15 7.325 14.4187 5.90625 13.2562 4.74375C12.0937 3.58125 10.675 3 8.99998 3C7.32498 3 5.90623 3.58125 4.74373 4.74375C3.58123 5.90625 2.99998 7.325 2.99998 9C2.99998 10.675 3.58123 12.0937 4.74373 13.2562C5.90623 14.4187 7.32498 15 8.99998 15Z" fill="#118043"/>
                  </svg>`
                    }
                ${resultado.city}
                ${
                  resultado.totalStock === 0
                    ? `<p style="color:#FF0000;">(${translations.stockUnavailable})</p>`
                    : `<p style="color:#0F8043;">(${translations.stockAvailable})</p>`
                }
                    </div>`;
          html += `<div class="store-variants">`;
          if (resultado.variants.length > 1) {
            html += `<div>${translations.talla}: </div>`;
          }

          resultado.variants.forEach((variante) => {
            if (variante.title !== "Default Title") {
              if (variante.stock > 0) {
                html += `<div>${variante.title}</div>`;
              } else {
                html += `<div><s style="opacity:0.5;">${variante.title}</s></div>`;
              }
            }
          });

          html += `</div>
                    <div class="store-location">
                        ${resultado.address}, ${resultado.city}, ${resultado.zip}
                    </div>
                    <div class="store-horario">
                        ${resultado.metafield}
                    </div>



                          <div class="store-phone">
                              <a href="tel:${resultado.phone}">${resultado.phone}</a>
                          </div>
                      </div>`;
        }
      });

      // Asignar el HTML generado al elemento con id "rocket-pickup"
      document.querySelector("#rocket-pickup").innerHTML = html;
    })
    .catch((error) => {
      console.error("Error fetching variant stock:", error);
    });
}

function moveButton() {
  let myMonogramBtn = document.getElementById("myMonogramBtn");
  let productStatusMessage = document.getElementById("btn-wrapper-pdp");
  if (myMonogramBtn && productStatusMessage) {
    productStatusMessage.appendChild(myMonogramBtn);
  }
}
